import { Stack } from "@chakra-ui/react";

interface ITemplateProps {
    children: React.ReactNode;
}

export default function Template({ children }: ITemplateProps) {
    return (
        <Stack justifyContent={"center"} alignItems={"center"} width={"100%"}>
            <Stack 
                width={{
                    base:"100%",
                    sm:"90%",
                    md:"80%",
                    lg:"70%",
                    xl:"70%"
                }} 
                paddingX={{
                    base:5,
                    sm:5,
                    md:5,
                    lg:10,
                    xl:10
                }}
                paddingY={{
                    base: 10,
                    sm: 10,
                    md: 10,
                    lg: 20,
                    xl: 20,
                }}
            >
                {children}
            </Stack>
        </Stack>
    );
}